module.exports = __webpack_public_path__ + "static/media/one.4c4884f9.svg";